import { render, staticRenderFns } from "./workspacesAiList.vue?vue&type=template&id=2f31fbc2&scoped=true"
import script from "./workspacesAiList.vue?vue&type=script&lang=js"
export * from "./workspacesAiList.vue?vue&type=script&lang=js"
import style0 from "./workspacesAiList.vue?vue&type=style&index=0&id=2f31fbc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f31fbc2",
  null
  
)

export default component.exports